import { render } from "./AdminVacancy.vue?vue&type=template&id=588d9a5a&scoped=true"
import script from "./AdminVacancy.vue?vue&type=script&lang=js"
export * from "./AdminVacancy.vue?vue&type=script&lang=js"

import "./AdminVacancy.vue?vue&type=style&index=0&id=588d9a5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588d9a5a"]])

export default __exports__